import React, { forwardRef } from 'react';

/**
 * Input component with label, error state, and helper text
 */
const Input = forwardRef(({ 
  label,
  type = 'text',
  id,
  name,
  value,
  onChange,
  onBlur,
  placeholder = '',
  error = null,
  helperText = '',
  required = false,
  disabled = false,
  className = '',
  ...props 
}, ref) => {
  // Generate an ID if not provided
  const inputId = id || `input-${name || Math.random().toString(36).substring(2, 9)}`;
  
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label 
          htmlFor={inputId}
          className="block text-sm font-medium text-gray-300 mb-2"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      <input
        ref={ref}
        type={type}
        id={inputId}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className={`w-full p-3 border rounded-md transition-all 
          ${error 
            ? 'border-red-500 bg-red-50 bg-opacity-10' 
            : 'border-gray-600 bg-[rgba(255,255,255,0.05)]'
          } 
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
          focus:outline-none focus:ring-2 focus:ring-[#7e55f6] text-white`}
        {...props}
      />
      
      {(error || helperText) && (
        <p className={`mt-1 text-sm ${error ? 'text-red-500' : 'text-gray-400'}`}>
          {error || helperText}
        </p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;